import { BRAND } from '@/brand/brand';

/**
 * Accent tones for user-created items (habits, lists, categories).
 *
 * They are derived from the brand rather than picked freely: an app where users choose from an
 * arbitrary rainbow stops looking like one product. Each entry stays within the brand's world while
 * being distinguishable at a glance on a small screen.
 *
 * Replace these with the assigned brand's secondary palette when applying a brand.
 */
export const TONES: string[] = [
	BRAND.color.primary,
	BRAND.color.success,
	BRAND.color.warning,
	BRAND.color.danger,
];
